export const INCREASE_CART_COUNT= 'INCREASE_CART_COUNT'
export const INCREASE_CART_COUNT_SUCCESS= 'INCREASE_CART_COUNT_SUCCESS'
export const INCREASE_CART_COUNT_ERROR='INCREASE_CART_COUNT_ERROR'

export const IncreaseCartCount= (data) => ({
    type: INCREASE_CART_COUNT,
    payload: data
})